import { createContext, useContext } from 'react';
import type { Draft } from 'immer';
import type { CustomButton } from '@types';

export const CustomButtonContext = createContext<{
  onChange: (
    fn: (draft: Draft<CustomButton[]>) => void | CustomButton[]
  ) => void;
}>({
  onChange: () => {},
});

export const useCustomButtonContext = () => {
  const context = useContext(CustomButtonContext);
  if (context === undefined) {
    throw new Error(
      'useCustomButtonSettingContext must be used within a CustomButtonSettingContext.Provider'
    );
  }
  return context;
};
